<script setup lang="ts">
import { ProposedDelivery, Subscription } from '@nuts/auto-delivery-sdk';
import { computed } from 'vue';

import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Caption from '@/components/base/typography/Caption.vue';
import Header5 from '@/components/base/typography/Header5.vue';
import SmallBodyText from '@/components/base/typography/SmallBodyText.vue';
import LineItemImage from '@/components/cart/added-modal/LineItemImage.vue';
import money from '@/filters/money';
import { getAutoDeliveryDetailsPath, getSubscriptionImage } from '@/utils/autoDelivery';
import { Money } from '@/utils/money';

const props = defineProps<{
  delivery: ProposedDelivery;
  subscription: Subscription;
}>();

defineEmits<{ manage: [] }>();

const isRecurring = computed(() => !!props.subscription.interval);

const autoDeliveryFrequencyText = computed(() => {
  if (props.subscription.interval) {
    return `${props.subscription.interval / 7} Week Frequency`;
  }
  return 'One time';
});

const hasDiscount = computed(() => {
  const { discountedPiecePrice, piecePrice } = props.subscription;
  return !Money.equals(discountedPiecePrice, piecePrice);
});
</script>

<template>
  <div class="flex gap-2 justify-between">
    <div class="flex gap-2">
      <LineItemImage
        :isPending="false"
        :linksToPdp="false"
        :name="subscription.name"
        :productPath="subscription.productPath"
        :titleImage="getSubscriptionImage(subscription)"
      />
      <div class="flex flex-col">
        <BaseBodyText class="font-semibold">
          {{ subscription.name.en }}
        </BaseBodyText>
        <div class="flex gap-2 items-center">
          <SmallBodyText class="mt-0.5">
            <template v-if="isRecurring">
              Auto-Delivery - <b>{{ autoDeliveryFrequencyText }}</b>
            </template>
            <template v-else>Will ship one time</template>
          </SmallBodyText>
          <RouterLink
            class="mt-1"
            :to="getAutoDeliveryDetailsPath(delivery)"
            @click="$emit('manage')"
          >
            <Caption class="underline text-nuts-cyan-700 hover:font-semibold">Manage</Caption>
          </RouterLink>
        </div>
        <div class="flex gap-2 items-center mt-2">
          <BaseBodyText class="text-neutral-500">Qty: {{ subscription.quantity }}</BaseBodyText>
          <Header5 class="font-semibold text-nuts-red-800">
            {{ money(subscription.discountedExtendedPrice) }}
          </Header5>
          <BaseBodyText v-if="hasDiscount" class="line-through text-neutral-500">
            {{ money(subscription.extendedPrice) }}
          </BaseBodyText>
        </div>
      </div>
    </div>
  </div>
</template>
